"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Spinner", {
  enumerable: true,
  get: function () {
    return _Spinner.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _Loader.default;
  }
});
var _Loader = _interopRequireDefault(require("./Loader"));
var _Spinner = _interopRequireDefault(require("./Spinner"));